import { TabsType } from "../../types/videoTranslationContext";

export const selectVideoOptionsActiveTabsInitial: Record<string, TabsType | null> = {
  translationTypeTab: null,
  translationOptionTab: null,
  chooseActor: null,
  setPositionTab: null,
};
